const UsageImportEventStatusEnum = {
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed',
}

export default UsageImportEventStatusEnum;